module.exports = __webpack_public_path__ + "img/laptop.41e245b1.svg";